import React from "react";
import "./Switch.scss";
import { useState } from "react";

const Switch = ({
  word1,
  word2,
  onChange,
  id,
  checked,
  disabled,
  label,
  labelFront,
  ...props
}) => {
  const [switchState, changeSwitchState] = useState(false);
  return (
    <div className="SwitchContainer">
      <p className="SwitchLabel Front">{labelFront}</p>
      <label className="Switch">
        <input
          checked={checked}
          id={id}
          type="checkbox"
          onClick={() => changeSwitchState(!switchState)}
          onChange={onChange}
          disabled={disabled}
          default
          /* onClick={(e) => this.setState({ frequency: !this.state.frequency })} */
        />
        <div className={checked ? "SwitchSlider" : "SwitchSlider Disabled"}>
          <span className={checked ? `True` : `False`}>
            {checked ? word1 : word2}
          </span>
        </div>
      </label>
      <p className="SwitchLabel">{label}</p>
    </div>
  );
};

export default Switch;
